import { MouseEvent as ReactMouseEvent } from 'react';

export const getTooltipPosition = (event: ReactMouseEvent<HTMLDivElement>) => {
  const { clientX, clientY, currentTarget } = event;
  const { top, left } = (currentTarget as Element).getBoundingClientRect();

  const position = {
    x: clientX,
    y: clientY,
  };

  const relativePosition = {
    x: position.x - left,
    y: position.y - top,
  };

  return { position, relativePosition };
};
